window.addEventListener('load', function() {
    // Get the current URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('print') === 'true') {
        setTimeout(function() {
            window.print();
        }, 500); // Delay to ensure print dialog opens after page load
    }
});